import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  setings: {},
  examList: [],
  examCategoryList: [],
  articleList: []
};

export default {
  namespaced: true,
  state,
  status,
  actions,
  getters,
  mutations
};
